import { render, staticRenderFns } from "./GExamDetailProgressOverallCharts.vue?vue&type=template&id=1f43b52c&scoped=true&"
import script from "./GExamDetailProgressOverallCharts.vue?vue&type=script&lang=ts&"
export * from "./GExamDetailProgressOverallCharts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f43b52c",
  null
  
)

export default component.exports